module.exports = __webpack_public_path__ + "9109459b3191353accb9909dedc7d3c1.svg";